/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 *
 * @author Evgeniy Naumov
 * @version 1.22.0
 * @since 1.22.0
 */

 import { IWizardOrderReportTranslation } from '../../types/wizards/orderReport';

 export const initWizardOrderReportTranslation: IWizardOrderReportTranslation = {
     title: '',
     steps: {
         ReportSelectionDataStep: '',
         ReportSelectionParametersStep: '',
         ReportConfirmStep: '',
     },
     error: {
         codes: {},
         defaultMessage: '',
     },
 };
